<template>
	<div class="mendian-page" :class="lang == 'ug' ? 'ug' : 'zh'" >
		<div class="mendian-page-header">
			<div class="main flex alcenter space">
				<div class="flex alcenter">
					<router-link to="/mendian">
					<img v-if="siteInfo!=null" :src="siteInfo.logo_white_account_manage" style="height: 24px;width: 148px;" />
					</router-link>
					<span class="title">{{ lang == 'ug' ? 'دۇكان باشقۇرۇش سۇپىسى' : '商户管理中心'}}</span>
				</div>
				<div class="flex alcenter">
					<span class="ft14 cl-w" :class="lang == 'ug' ? 'ml10' : 'mr10'" >{{ lang == 'ug' ? 'ھۈرمەتلىك ' : '欢迎您，'}}{{account.username}}{{ lang == 'ug' ? '، ياخشىمۇسىز!' : ''}}</span>
						<a-button shape="round"  @click="loginOut()">
							{{ lang == 'ug' ? 'چېكىنىش' : '退出'}}
						</a-button>

				</div> 
			</div>
		</div>
		
		<div class="mt40" style="flex: auto;">
			<div class="mendian-page-main">
				<router-view></router-view>
			</div>
		</div>
		
		<div style="direction: ltr;" class="mendian-footer text-center pd24_20 ft14 cl-info">©2017-{{getNowYear}} {{siteInfo ? siteInfo.domain : ''}} </div>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				account:{
					mobile:'',
					user_name:'',
					face:'',
				},
				lang: localStorage.getItem('lang'),
				siteInfo:null,
			}
		},
		computed:{
			getNowYear(){
				let date = new Date();
				return date.getFullYear(); 
			}
		},
		created(){
			this.showTime();
			this.getSiteInfo();
			this.getLayoutData();
			
		},
		methods:{
			getSiteInfo(){
				this.$http.api('platform/siteInfo').then(res=>{
					this.siteInfo = res.site;
				}).catch(res=>{
					console.log(res);
				});
			},
			showTime(){
				var now = new Date()
				var hour = now.getHours()
				var t = ''
				if (hour < 6) {
				  t = this.lang == 'ug' ? 'سۈبھىدىن باشلىنار سەھەر' :'凌晨好'
				} else if (hour < 9) {
				  t = this.lang == 'ug' ? 'خەيرىلىك سەھەر' :'早上好'
				} else if (hour < 12) {
				  t = this.lang == 'ug' ? 'چۈشتىن بۇرۇنلىقىڭىز خەيرىلىك بولسۇن' :'上午好'
				} else if (hour < 14) {
				  t = this.lang == 'ug' ? 'چۈشلۈكىڭىز خەيرىلىك بولسۇن' :'中午好'
				} else if (hour < 17) {
				  t = this.lang == 'ug' ? 'چۈشتىن كېيىنلىكىڭىز خەيرىلىك بولسۇن' :'下午好'
				} else if (hour < 19) {
				  t = this.lang == 'ug' ? 'كەچقۇرۇنلىقىڭىز خەيرىلىك بولسۇن' :'傍晚好'
				} else if (hour < 22) {
				  t = this.lang == 'ug' ? 'كەچلىكىڭىز خەيرىلىك بولسۇن' :'晚上好'
				} else {
				  t = this.lang == 'ug' ? 'خەيرىلىك كېچە' :'夜里好'
				}
				this.showT = t;
			},
			
			getLayoutData(){
				this.$http.api('platform/account/layout').then(res=>{
					this.account=res.account;
				}).catch(res=>{
					console.log(res);
				})
			},
			// switch_language(lang){
			// 	console.log(lang)
			// 	if(lang == 'ug'){
			// 		localStorage.setItem('lang','zh');
			// 		this.lang = 'zh'
			// 	}else{
			// 		localStorage.setItem('lang','ug');
			// 		this.lang = 'ug'
			// 	}
				
			// },
			loginOut(){
				localStorage.removeItem('account-token');
				this.$router.push('/');
			}
		}
	}
</script>

<style>
	.mendian-footer{
		    flex: 0 0 auto;
	}
	.mendian-list{
		display: grid;
		grid-template-columns: repeat(3,380px);   
		grid-template-rows: repeat(3,100px); 
		grid-column-gap: 30px; 
		grid-row-gap: 30px;
	}
	.mendian-item{
		width: 380px;
		height: 100px;
		background: #FFFFFF;
		border-radius: 8px;
		border-left: 8px solid #EBEDF5;
		padding: 24px 16px;
		cursor: pointer;
		transition: all 0.3s;
	}
	.ug .mendian-item{
		border-right: 8px solid #EBEDF5;
		border-left: unset;
	}
	.mendian-item .tag{
		width: 52px;
		height: 20px;
		border-radius: 10px;
		border: 1px solid #4772FF;
		text-align: center;
		line-height: 18px;
		font-size: 12px;
		color:#4772FF;
	}
	.mendian-item:hover{
		transform: translateY(-10px);
	}
	.mendian-item.add{
		border: 1px dashed #4772FF;
	}
	.mendian-page{
		min-width: 1200px;
		min-height: 100vh;
		display: flex;
		flex: auto;
		flex-direction: column;
	}
	.mendian-page-header{
		width: 100%;
		height: 60px;
		background: #4772FF;
		flex: 0 0 auto;
	}
	.mendian-page-header .main{
		width: 1200px;
		height: 60px;
		margin: 0 auto;
	}
	.mendian-page-header .log-out{
		width: auto;
		height: 24px;
		border-radius: 4px;
		border: 1px solid #FFFFFF;
		text-align: center;
		line-height: 22px;
		font-size: 14px;
		color:#FFFFFF;
		cursor: pointer;
		padding: 0 10px;
	}
	.mendian-page-header .switch_language{
		margin-right: 10px;
	}
	.ug .mendian-page-header .switch_language{
		margin-right: unset;
		margin-left: 10px;
	}
	.mendian-page-header .title{
		font-size: 20px;
		font-weight: 600;
		color:#FFFFFF;
		padding-left: 12px;
		border-left: 1px solid #FFFFFF;
		margin-left: 12px;
		height: 20px;
		line-height: 20px;
	}
	.ug .mendian-page-header .title{
		padding-left: unset;
		border-left: unset;
		margin-left: unset;
		padding-right: 12px;
		border-right: 1px solid #FFFFFF;
		margin-right: 12px;
	}
	.mendian-page-main{
		width: 1200px;
		margin: 0 auto;
		
	}
</style>